'use client';

import { useEffect, useRef } from 'react';
import toast from 'react-hot-toast';

// Replaced at bundle-build time by webpack DefinePlugin (next.config.js).
// Undefined in local dev when APP_VERSION is not set — check is skipped.
declare const process: { env: { NODE_ENV?: string; NEXT_BUILD_ID?: string } };
const CLIENT_BUILD_ID = process.env.NEXT_BUILD_ID;

const CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export default function DeploymentCheck() {
    const notified = useRef(false);

    useEffect(() => {
        if (process.env.NODE_ENV !== 'production' || !CLIENT_BUILD_ID) return;

        async function check() {
            if (notified.current) return;
            try {
                const res = await fetch('/api/version', { cache: 'no-store' });
                if (!res.ok) return;
                const { buildId } = await res.json();
                if (buildId && buildId !== CLIENT_BUILD_ID) {
                    notified.current = true;
                    toast(
                        () => (
                            <span>
                                A new version is available.{' '}
                                <button
                                    onClick={() => window.location.reload()}
                                    style={{ textDecoration: 'underline', cursor: 'pointer', background: 'none', border: 'none', padding: 0, font: 'inherit' }}
                                >
                                    Reload now
                                </button>
                            </span>
                        ),
                        { id: 'deployment-update', duration: Infinity },
                    );
                }
            } catch {
                // Non-fatal — version endpoint unreachable
            }
        }

        check();

        // Check on visibility change (user returns to a backgrounded tab)
        const onVisible = () => {
            if (document.visibilityState === 'visible') check();
        };
        document.addEventListener('visibilitychange', onVisible);
        const interval = setInterval(check, CHECK_INTERVAL_MS);

        return () => {
            document.removeEventListener('visibilitychange', onVisible);
            clearInterval(interval);
        };
    }, []);

    return null;
}
